import Vue from 'vue'

export const namespaced = true

export const state = {
  clients: [],
  client: {},
  total: 0,
  page: 1,
  limit: 10,
  clientsLoading: false,
  clientLoading: false
}

//MUTATIONS are synchronous : mutate / update state => this.$store.commit('ADD_EVENT')
export const mutations = {

  SET_CLIENTS_LIST (state, clients) {
    // console.log(clients)
    state.clients = clients
  },

  SET_CLIENT (state, client) {
    state.client = client
  },

  SET_CLIENTS_TOTAL (state, total) {
    state.total = total
  },

  SET_CLIENTS_LOADING (state, loading) {
    state.clientsLoading = loading
  },

  SET_CLIENT_LOADING (state, loading) {
    state.clientLoading = loading
  },

  DELETE_CLIENT_INTERLOCUTOR (state, index) {
    state.client.interlocuteurs.slice(index, 1)
  },

  EDIT_CLIENT_INTERLOCUTOR (state, {index, interlocuteur}) {
    state.client.interlocuteurs[index] = { ...interlocuteur }
  },

  ADD_CLIENT_INTERLOCUTOR (state, interlocuteur) {
    state.client.interlocuteurs.push(interlocuteur)
  }
}

//ACTIONS are assynchronous : actions fetch datas (AJAX) then send results to mutations (to update local state)  => this.$store.dispatch('createEvent')
export const actions = {

  getAllClients ({ commit, dispatch }, { page, limit }) {
    commit('SET_CLIENTS_LOADING', true)
    //check values or take default
    page = page ? page : state.page
    limit = limit ? limit : state.limit

    return Vue.axios.get(`/debiteurs?page=${page}&limit=${limit}`)
      .then(response => {
        commit('SET_CLIENTS_LIST', response.data)
        commit('SET_CLIENTS_TOTAL', response.headers['x-total-count'])
        commit('SET_CLIENTS_LOADING', false)
      })
      .catch(error => {
        commit('SET_CLIENTS_LOADING', false)
        dispatch('displayError', {message: 'Erreur de chargement des clients', error}, {root: true})
      })
  },

  getClient ({commit, dispatch}, id) {
    commit('SET_CLIENT_LOADING', true)
    return Vue.axios.get(`/debiteurs/${ id }`)
      .then(response => {
        commit('SET_CLIENT', response.data)
        commit('SET_CLIENT_LOADING', false)
      })
      .catch(error => {
        commit('SET_CLIENT_LOADING', false)
        dispatch('displayError', {message: 'Erreur de chargement du client', error}, {root: true})
      })
  },

  saveClient ({ commit, dispatch }, client) {
    commit('SET_CLIENT_LOADING', true)
    if (!client.id || client.id === -1) {
      return Vue.axios.post('/debiteurs', client)
        .then(() => {
          commit('SET_CLIENT_LOADING', false)
          dispatch('displaySuccess', 'Client créé', {root: true})
        })
        .catch(error => {
          commit('SET_CLIENT_LOADING', false)
          const nofitication = {
            type: 'danger',
            message: `Erreur lors de la création du client: ${  error.message}`
          }
          dispatch('notification/add', nofitication, { root: true })
          throw error
        })
    } else {
      return Vue.axios.put(`/debiteurs/${client.id}`, client)
        .then(() => {
          commit('SET_CLIENT_LOADING', false)
          dispatch('displaySuccess', 'Client mis à jour', {root: true})
        })
        .catch(error => {
          dispatch('displayError', {message: 'Erreur de modification du client', error}, {root: true})
          throw error
        })
    }
  },

  deleteClient ({ commit, dispatch }, id) {
    commit('SET_CLIENT_LOADING', true)
    return Vue.axios.delete(`/debiteurs/${id}`)
      .then(() => {
        commit('SET_CLIENT', {})
        commit('SET_CLIENT_LOADING', false)
        dispatch('displaySuccess', 'Client supprimé', {root: true})
      })
      .catch(error => {
        commit('SET_CLIENT_LOADING', false)
        dispatch('displayError', {message: 'Erreur de suppression du client', error}, {root: true})
      })
  },

  deleteClientInterocuteur ({ commit, dispatch }, index) {
    commit('DELETE_CLIENT_INTERLOCUTOR', index)
    dispatch('saveClient', state.client)
  },
  editClientInterlocuteur ({ commit, dispatch }, {index, interlocuteur }) {
    commit('EDIT_CLIENT_INTERLOCUTOR', { index, interlocuteur })
    dispatch('saveClient', state.client)
  },
  addClientInterlocuteur ({ commit, dispatch }, interlocuteur) {
    commit('ADD_CLIENT_INTERLOCUTOR', interlocuteur)
    dispatch('saveClient', state.client)
  }
}
